import React from 'react';
import '../../App.css';
function Registro() {
    return (
        <div>
            <h1 className="sing-up">Registro</h1>
        </div>
    )
}

export default Registro
